export const SET_OFFER = 'SET_OFFER';
export const SET_USER_SIGNED_UP = 'SET_USER_SIGNED_UP';
export const SET_OFFER_STORE = 'SET_OFFER_STORE';
export const SET_GLOBAL_ALERT = 'SET_GLOBAL_ALERT';
export const UPDATE_OFFER = 'UPDATE_OFFER';
export const SHOW_SPLASH_SCREEN = 'SHOW_SPLASH_SCREEN';
export const SET_CALLBACK_AUTH = 'SET_CALLBACK_AUTH';
export const SET_TAB_PADDING_TOP = 'SET_TAB_PADDING_TOP';
export const RESET_OFFER_STORE = 'RESET_OFFER_STORE';
export const SET_OAUTH_SETTINGS = 'SET_OAUTH_SETTINGS';

/**
 * @param {import('../reducers/offer.reducer').Offer} offer
 * @returns
 */
export const setOffer = (offer) => ({
  type: SET_OFFER,
  payload: offer
});

/**
 * @param {bool} userSignedUp
 * @returns
 */
export const setUserSignedUp = (userSignedUp) => ({
  type: SET_USER_SIGNED_UP,
  payload: userSignedUp
});

/**
 *
 * @param {import('../reducers/offer.reducer').OfferStore} store
 * @returns
 */
export const setOfferStore = (store) => ({
  type: SET_OFFER_STORE,
  payload: store
});

/**
 *
 * @param {any} content
 * @param {'success'|'danger'} variant
 * @param {bool} shouldUpdateOffer
 * @returns
 */
export const setGlobalAlert = ({
  content = null,
  variant = 'success',
  shouldUpdateOffer = false,
}) => dispatch => {
  if (shouldUpdateOffer) dispatch(updateOffer());

  dispatch({
    type: SET_GLOBAL_ALERT,
    payload: content ? {
      content,
      variant
    } : null
  });
};

export const updateOffer = () => ({
  type: UPDATE_OFFER,
  payload: Date.now()
});

/**
 *
 * @param {bool} show
 * @param {any} message
 * @param {number} timeout
 * @returns
 */
export const showSplashScreen = (show, message, timeout) => ({
  type: SHOW_SPLASH_SCREEN,
  payload: {
    show,
    text: message,
    timeout
  }
});

export const setCallbackAuth = (callback) => ({
  type: SET_CALLBACK_AUTH,
  payload: callback
});


export const setTabPaddingTop = (callback) => ({
  type: SET_TAB_PADDING_TOP,
  payload: callback
});

export const resetOfferStore = () => ({
  type: RESET_OFFER_STORE,
})

export const setupOauthSettings = (settings) => ({
  type: SET_OAUTH_SETTINGS,
  payload: settings
});